import src from "IMAGE";
export default { src, width: 512, height: 512, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAMElEQVR42r2POwoAAAhC65TV/S9S0GcIckx4izooUYoPJpRAF9IlLsMW+lyAI+FNB2KsDIXgDXtPAAAAAElFTkSuQmCC"};
